import AppBar from '@mui/material/AppBar';
import React, {useEffect, useState} from 'react';
import {Outlet, useNavigate} from 'react-router-dom';
import '../../App.css';
import {logout} from '../../api/auth';
import logoImage from '../../assets/images/forest-logo.png';
import {useAddepar} from '../../hooks/use-adepar';
import {useAuth} from '../../hooks/use-auth';
import {useBill} from '../../hooks/use-bill';
import {useBridge} from '../../hooks/use-bridge';
import {usePlaid} from '../../hooks/use-plaid';
import {PlaidLinkModal} from '../Plaid/PlaidLinker';
import {AddeparModal} from './AddeparModal';
import {BillModal} from './BillModal';
import {BridgeFTLinkModal} from './BridgeFTModal';

function Navbar({user, children}) {
  const {
    state: {profile},
    getProfile,
  } = useAuth();
  const {fetchInitialFromDB} = usePlaid();
  const {fetchInitialBill} = useBill();
  const {fetchInitialAddepar} = useAddepar();
  const {fetchInitialBridge} = useBridge();

  const admin = !!profile.admin;

  useEffect(() => {
    if (user?.uid) {
      // ONLY PULL CURRENT USER INFO IF NOT ADMIN
      if (!admin) {
        fetchInitialFromDB(user.uid);
        fetchInitialBill(user.uid);
        fetchInitialAddepar(user.uid);
        fetchInitialBridge(user.uid);
      }
      getProfile(user.uid);
    }
  }, [user?.uid]);

  return (
    <div>
      <AppBar position="static" sx={{backgroundColor: '#f6f6f6'}}>
        <div className="flex-row justify-between align-center">
          <img
            alt="Forest Connect Logo"
            className="logo-image"
            style={{width: '200px', height: '58px'}}
            src={logoImage}
          />
          {user ? (
            admin ? (
              <AdminBar user={user} />
            ) : (
              <UserBar user={user} />
            )
          ) : null}
        </div>
      </AppBar>
      {children || <Outlet />}
    </div>
  );
}

const AdminBar = ({user}) => {
  const {reset} = useAuth();
  const {resetPlaid} = usePlaid();
  const navigate = useNavigate();

  const logOut = async () => {
    await logout();
    reset();
    resetPlaid();
    navigate('/');
  };

  return (
    <div className="flex-row">
      <button
        className="gray-button"
        onClick={() => {
          navigate('/admin/user/dashboard');
        }}>
        Users
      </button>
      <button
        className="gray-button"
        onClick={() => {
          navigate('/admin/client/dashboard');
        }}>
        Clients
      </button>
      <button className="gray-button" onClick={logOut}>
        Log out
      </button>
    </div>
  );
};

const UserBar = ({user}) => {
  const navigate = useNavigate();

  const {
    state: {profile, client},
  } = useAuth();

  const [connect, setConnect] = useState(false);
  const [connectAddepar, setConnectAddepar] = useState(false);
  const [connectBridgeFT, setConnectBridgeFT] = useState(false);

  const logOut = async () => {
    await logout();
    navigate('/');
  };

  return (
    <>
      <div className="flex-row">
        {client?.addepar && (
          <button
            style={{
              zIndex: 1,
              backgroundColor: '#c5c7c6',
              height: '30px',
              border: '1.2px solid black',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              padding: '0px 32px',
              margin: '0px 8px',
              fontSize: 12,
            }}
            onClick={async () => {
              // const url =
              //   process.env.REACT_APP_ADDEPAR_OAUTH ||
              //   'https://forestsystems.clientdev.addepar.com/oauth2/authorize?response_type=code&scope=entities+portfolio+profile+transactions+transactions_write+snapshots+snapshots_write&client_id=forestsys_dev&redirect_uri=https%3A%2F%2Fforest-systems-plaid-dev.web.app%2FaddeparConnect';

              const url2 =
                'https://forestsystems.clientdev.addepar.com/oauth2/authorize?response_type=code&scope=entities+portfolio+profile+transactions+transactions_write&client_id=forestsys_dev&redirect_uri=https%3A%2F%2Fforest-systems-plaid-dev.web.app%2FaddeparConnect';

              window.location.href = url2;
            }}>
            Connect Addepar
          </button>
        )}
        {/* {client?.addepar && (
          <button
            style={{
              zIndex: 1,
              backgroundColor: '#c5c7c6',
              height: '30px',
              border: '1.2px solid black',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              padding: '0px 32px',
              margin: '0px 8px',
              fontSize: 12,
            }}
            onClick={() => {
              setConnectAddepar(!connectAddepar);
            }}>
            Connect Addepar
          </button>
        )} */}
        {client?.bill && (
          <button
            style={{
              zIndex: 1,
              backgroundColor: '#ff5605',
              height: '30px',
              border: '0px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              padding: '0px 32px',
              margin: '0px 8px',
              fontSize: 12,
              border: '1.2px solid #c5c7c6',
            }}
            onClick={() => {
              setConnect(!connect);
            }}>
            Connect Bill.com
          </button>
        )}

        {client?.plaid && <PlaidLinkModal user={user} />}
        {client?.bridgeft && (
          <button
            style={{
              zIndex: 1,
              backgroundColor: 'blue',
              color: 'white',
              height: '30px',
              border: '0px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              padding: '0px 32px',
              margin: '0px 8px',
              fontSize: 12,
              border: '1.2px solid #c5c7c6',
            }}
            onClick={() => {
              setConnectBridgeFT(!connectBridgeFT);
            }}>
            Connect Custodian
          </button>
        )}

        <button
          style={{
            zIndex: 1,
            backgroundColor: '#c5c7c6',
            height: '30px',
            border: '1.2px solid black',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '0px 32px',
            margin: '0px 8px',
            fontSize: 12,
          }}
          onClick={logOut}>
          Log out
        </button>
      </div>
      {connect && <BillModal active={connect} setActive={setConnect} />}
      {connectAddepar && (
        <AddeparModal active={connectAddepar} setActive={setConnectAddepar} />
      )}
      {connectBridgeFT && (
        <BridgeFTLinkModal
          active={connectBridgeFT}
          setActive={setConnectBridgeFT}
        />
      )}
    </>
  );
};

export default Navbar;
